module.exports = __webpack_public_path__ + "static/media/SarahSwitek_02_HowAreYouFeeling_9.33f253a3.mp3";